import React from 'react';
import Icon from '../../../components/AppIcon';
import { formatDistanceToNow } from 'date-fns';

const RecentActivity = ({ activities }) => {
  const getActivityIcon = (activity) => {
    return 'Dumbbell';
  };

  const getActivityColor = () => {
    return 'var(--color-accent)';
  };

  return (
    <div className="bg-card rounded-xl shadow-md p-6">
      <h2 className="text-xl font-heading font-bold text-foreground mb-6 flex items-center gap-2">
        <Icon name="Activity" size={24} color="var(--color-primary)" />
        Recent Activity
      </h2>

      <div className="space-y-4 max-h-[600px] overflow-y-auto">
        {activities?.length === 0 ? (
          <div className="text-center py-12">
            <Icon name="Activity" size={48} color="var(--color-muted-foreground)" className="mx-auto mb-4 opacity-50" />
            <p className="text-muted-foreground">No recent activity</p>
          </div>
        ) : (
          activities?.map((activity) => (
            <div
              key={activity?.id}
              className="flex gap-4 p-4 bg-background rounded-lg border border-border hover:border-primary transition-smooth"
            >
              <div className="flex h-10 w-10 items-center justify-center rounded-full bg-accent/10 flex-shrink-0">
                <Icon name={getActivityIcon(activity)} size={20} color={getActivityColor()} />
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-foreground text-sm mb-1">
                  {activity?.user_profiles?.full_name || 'Member'}
                </p>
                <p className="text-sm text-muted-foreground mb-2">
                  Completed: {activity?.title}
                </p>
                <div className="flex items-center gap-4 text-xs text-muted-foreground">
                  <span className="flex items-center gap-1">
                    <Icon name="Clock" size={14} />
                    {activity?.duration_minutes} min
                  </span>
                  <span className="flex items-center gap-1">
                    <Icon name="Flame" size={14} />
                    {activity?.calories_burned} cal
                  </span>
                  <span>
                    {formatDistanceToNow(new Date(activity?.created_at), { addSuffix: true })}
                  </span>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default RecentActivity;